'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
require('../node_modules/prop-types/index.js');
var clsx_m = require('../node_modules/clsx/dist/clsx.m.js');
require('@material-ui/core/IconButton');
require('@material-ui/icons/EditRounded');
require('@material-ui/icons/RemoveCircleRounded');
require('@material-ui/icons/FavoriteRounded');
var useDataTable = require('./useDataTable.js');
var Checkbox = require('../Checkbox/Checkbox.js');
var Cell = require('./Cell.js');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var Row = _ref => {
  var {
    rowIndex,
    top,
    rowHeight,
    actionsWidth,
    scrollbarWidth
  } = _ref;
  var {
    columns,
    rows,
    selected,
    selectionMode,
    toggleSelectRow,
    renderActions
  } = useDataTable.useDataTable();
  var row = rows === null || rows === void 0 ? void 0 : rows[rowIndex];
  var isSelected = !(row !== null && row !== void 0 && row.id) ? false : selectionMode === 'include' ? selected.has(row === null || row === void 0 ? void 0 : row.id) : !selected.has(row === null || row === void 0 ? void 0 : row.id);

  function handleKeyPress(event) {
    if (event.key === 'Enter' || event.key === " ") {
      toggleSelectRow(event, row === null || row === void 0 ? void 0 : row.id, rowIndex);
    }
  }

  return /*#__PURE__*/React__namespace.createElement("div", {
    role: "row",
    tabIndex: 0,
    onClick: event => toggleSelectRow(event, row === null || row === void 0 ? void 0 : row.id, rowIndex),
    onKeyPress: handleKeyPress,
    onMouseDown: event => {
      // If there are selected elements we need to prevent the mouseDown
      // event from selecting text because this interfere's with the shift-
      // click to select functionality.
      if (selected.size && event.shiftKey) {
        event.preventDefault();
      }
    },
    className: clsx_m('GenjoDataTable__row', 'GenjoDataTable__data-row', {
      'is-selected': isSelected
    }),
    style: {
      height: rowHeight,
      maxHeight: rowHeight,
      minHeight: rowHeight,
      top
    }
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: "GenjoDataTable__cell",
    style: {
      width: rowHeight,
      maxWidth: rowHeight,
      minWidth: rowHeight
    }
  }, Boolean(row === null || row === void 0 ? void 0 : row.id) && /*#__PURE__*/React__namespace.createElement(Checkbox.Checkbox, {
    checked: isSelected
  })), columns.map((column, columnIndex) => /*#__PURE__*/React__namespace.createElement(Cell.Cell, {
    key: column.dataKey,
    rowIndex: rowIndex,
    columnIndex: columnIndex,
    row: row,
    value: row === null || row === void 0 ? void 0 : row[column.dataKey],
    width: column.width
  })), actionsWidth > 0 && /*#__PURE__*/React__namespace.createElement("div", {
    className: "GenjoDataTable__cell",
    style: {
      height: rowHeight,
      width: actionsWidth - scrollbarWidth,
      maxWidth: actionsWidth - scrollbarWidth,
      minWidth: actionsWidth - scrollbarWidth
    }
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: "GenjoDataTable__actions"
  }, renderActions === null || renderActions === void 0 ? void 0 : renderActions(rowIndex, row))));
};
Row.propTypes = {};

exports.Row = Row;
